import { render } from "./NewFeature.vue?vue&type=template&id=fd6979f6&scoped=true"
const script = {}

import "./NewFeature.vue?vue&type=style&index=0&id=fd6979f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd6979f6"]])

export default __exports__